import { IAuthUser } from 'auth/types';
import { AgGridFilterOption } from 'core/enums';
import { QuoteEntityType, QuoteState, QuoteStatus } from 'quotes/enums';
import { ICustomerQuote } from 'quotes/types';

export const getInitialState = (entityType = QuoteEntityType.QUOTE, user: IAuthUser) => {
  switch (entityType) {
    case QuoteEntityType.ORDER:
      return {
        filter: {
          filterModel: {
            vendorCorporateUserName: {
              filterType: 'text',
              type: AgGridFilterOption.CONTAINS,
              filter: `${user?.firstName} ${user?.lastName}`,
            },
            archived: { filterType: 'set', values: [QuoteState.ACTIVE] },
            createdAt: {
              filterType: 'date',
              type: AgGridFilterOption.RELATIVE_LAST_30_DAYS,
            },
          },
        },
      };
    case QuoteEntityType.QUOTE:
    default:
      return {
        filter: {
          filterModel: {
            ownerUserName: {
              filterType: 'text',
              type: AgGridFilterOption.CONTAINS,
              filter: `${user?.firstName} ${user?.lastName}`,
            },
            archived: { filterType: 'set', values: [QuoteState.ACTIVE] },
            updatedAt: {
              filterType: 'date',
              type: AgGridFilterOption.RELATIVE_LAST_90_DAYS,
            },
          },
        },
      };
  }
};

export const getQuoteStatuses = (entityType: QuoteEntityType) => {
  switch (entityType) {
    case QuoteEntityType.ORDER:
      return [
        QuoteStatus.ORDER_DRAFT_VENDOR,
        QuoteStatus.ORDER_REQUESTED_BY_CUSTOMER,
        QuoteStatus.ORDER_ORDERING,
        QuoteStatus.ORDER_ORDERED,
        QuoteStatus.ORDER_ORDER_FAILED,
        QuoteStatus.ORDER_SUBMISSION_TIMED_OUT,
        QuoteStatus.ORDER_ACCEPTED,
        QuoteStatus.ORDER_CANCELED,
        QuoteStatus.ORDER_SHIPPED_PARTIAL,
        QuoteStatus.ORDER_SHIPPED_COMPLETE,
      ];
    case QuoteEntityType.QUOTE:
    default:
      return [
        QuoteStatus.DRAFT,
        QuoteStatus.OPEN,
        QuoteStatus.EDITABLE_BY_CUSTOMER,
        QuoteStatus.WON,
        QuoteStatus.PUNCHED_OUT,
        QuoteStatus.LOST,
      ];
  }
};

// Statuses whose externalOrderErrorMessage explains how the order got there.
const STATUSES_CARRYING_ERROR_MESSAGE = [
  QuoteStatus.ORDER_ORDER_FAILED,
  QuoteStatus.ORDER_SUBMISSION_TIMED_OUT,
];

// Why an order failed or stalled, surfaced on the status chip; nothing for any other status.
export const getOrderStatusTooltip = (
  quote?: Pick<ICustomerQuote, 'status' | 'externalOrderErrorMessage'> | null
): string | null =>
  STATUSES_CARRYING_ERROR_MESSAGE.includes(quote?.status) && quote.externalOrderErrorMessage
    ? quote.externalOrderErrorMessage
    : null;
